import React from 'react'
import { Link } from 'gatsby'
import resolveLink from 'src/utils/resolveLink'

const BackButton = ({component}) => {
    const target = 
        component === 'vacancy' ? '/vacancies/'
        : component === 'resource' ? '/resources/'
        : component === 'webinar' ? '/webinars/'
        : component === 'news' ? '/news/'
        : component === 'success_story' ? '/success-stories/'
        : component === 'whitepaper' ? '/whitepapers/'
        : component === 'solution' ? '/solutions/'
        : component === 'insight' ? '/insights/'
        : component === 'blog' ? '/insights/?refinementList%5Bfield_component%5D%5B0%5D=blog&page=1'
        : '/'

    const text = component === 'vacancy' ? 'Work with us' : 'Back'
    
    return (
        <Link to={resolveLink(target)} className="!font-normal !text-blue hover:!text-teal text-base py-2 pr-2 mb-12 inline-block duration-300">
            <i className="fa-regular fa-chevron-left w-2 mr-2"></i> 
            {text}
        </Link>
    )
}

export default BackButton